import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSummaryTrial = async (trialId) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/get_summary_trial/${trialId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetSummaryTrial = ({ trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["summary_trial", trialId],
    queryFn: () => fetchSummaryTrial(trialId),
    enabled: enabled && Boolean(trialId),
  });
};

export default useGetSummaryTrial;
